import axios from 'axios';
import qs from 'qs';

// if (process.env.NODE_ENV === 'production') {
//     axios.defaults.baseURL = URL_PREFIX_SERVICE
// } else {
//     axios.defaults.baseURL = '/dev';
// }

axios.defaults.baseURL = URL_PREFIX_SERVICE;
console.log(URL_PREFIX_SERVICE, 'process.env', axios.defaults.baseURL)

axios.interceptors.request.use(
    config => {
        config.headers = {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        };
        return config;
    },
    function(error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 添加响应拦截器
axios.interceptors.response.use(
    res => {
        if (res.status == 200) {
            if (res.data.status) {
                if (res.data.status.code === "04520003") {
                    Message.error("已超时");
                } else {
                    return res;
                }
            } else {
                return res
            }
        }
    },
    error => {
        // 请求错误时做些事
        return Promise.reject(error);
    }
);
axios.defaults.transformRequest = data => {
    if (typeof data === 'object' && !data.append) {
        return qs.stringify(data);
    } else {
        return data;
    }
};
axios.plugin = {
    install(Vue) {
        Object.defineProperty(Vue.prototype, '$http', { value: axios });
    },
};
export default axios;


// WEBPACK FOOTER //
// ./src/utils/request.js